import gameIds from '../../hub/data/GameIds';

export const GAME_ID = gameIds.WORDBOTS;

export const CONTENT_TYPES = {
  COMPOUND: 'compound',
  SYLLABLE: 'syllable',
  ONSETRIME: 'onsetrime',
};

export const ONBOARDING_PHASES = {
  INTRO: 'ONBOARDING_INTRO',
  CLICK_BOT: 'ONBOARDING_CLICK_BOT',
  DRAG_BOT: 'ONBOARDING_DRAG_BOT',
  MERGE_BOTS: 'ONBOARDING_MERGE_BOTS',
};

export const SCREENS = {
  LOADING: 'WORDBOTS_LOADING',
  PROGRESS: 'WORDBOTS_PROGRESS',
  ONBOARDING: 'WORDBOTS_ONBOARDING',
  HELP: 'WORDBOTS_HELP',
  STANDARD: 'WORDBOTS_STANDARD',
  PRACTICE: 'WORDBOTS_PRACTICE',
};

export const NUM_STANDARD_BACKGROUNDS = 6;
